<!-- End Navbar -->
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary" style="height: 3.75rem">
            <h4 class="card-title ">{{ sociedad }}</h4>
          </div>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <th>{{ 'texto_43' | translate }}</th>
                  <th>{{ 'texto_44' | translate }}</th>
                  <th>{{ 'texto_38' | translate }}</th>
                  <th>{{ 'texto_46' | translate }}</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of abogados; let i = index">
                    <td>{{ item.id_abogado }}</td>
                    <td>{{ item.n_abogado }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.comentario }}</td>
                    <td class="td-actions text-right">
                      <button (click)="showLayer(item)" type="button" title="Edit Lawyer"
                        style="background: none; color: black; border: none;">
                        <i class="material-icons">edit</i>
                      </button>
                      <button (click)="deleteLayer(item.id_abogado)" type="button" title="Remove"
                        style="background: none; color: red; border: none;">
                        <i class="material-icons">clear</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br><br>

              <div [style.display]="IsHiddenForm ? 'block' : 'none'" style="width: 400px !important; margin: 0 auto;"
                class="modal" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true">

                <div class="modal-dialog cascading-modal modal-avatar modal-sm" style="max-width: 400px;"
                  role="document">
                  <div class="modal-content" style="width: 400px !important;">

                    <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
                      <div class="card-header card-header-info">
                        <h5 class="card-title mb-0">{{ 'texto_47' | translate }}</h5>
                      </div>

                      <button type="button" class="btn btn-dark" style="z-index:100; float: right; margin-top: -2.8rem;"
                        (click)="hideModal()" aria-label="Cerrar modal">X</button>

                      <form [formGroup]="validatingForm">
                        <!-- ID -->
                        <div class="md-form mb-3 col-md-12 px-0">
                          <input type="text" class="form-control" formControlName="signupFormModalId" mdbInput readonly>
                          <label class="active">ID</label>
                        </div>

                        <!-- Nombre -->
                        <div class="md-form mb-3 col-md-12 px-0">
                          <input type="text" class="form-control" formControlName="signupFormModalName" mdbInput
                            maxlength="255">
                          <label class="active">{{ 'texto_44' | translate }}</label>
                          <mdb-error
                            *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
                            {{ 'texto_61' | translate }}
                          </mdb-error>
                          <mdb-success
                            *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
                            {{ 'texto_62' | translate }}
                          </mdb-success>
                        </div>

                        <!-- Email -->
                        <div class="md-form mb-3 col-md-12 px-0">
                          <input type="text" class="form-control" formControlName="signupFormModalEmail" mdbInput>
                          <label class="active">Email</label>
                          <mdb-error
                            *ngIf="signupFormModalEmail.invalid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                            {{ 'texto_61' | translate }}
                          </mdb-error>
                          <mdb-success
                            *ngIf="signupFormModalEmail.valid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                            {{ 'texto_62' | translate }}
                          </mdb-success>
                        </div>

                        <!-- Comentario -->
                        <div class="md-form col-md-12 px-0">
                          <label class="active">{{ 'texto_46' | translate }}</label>
                          <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 20%;"></mdb-icon>
                          <textarea maxlength="4000" class="md-textarea form-control" rows="5" mdbInput
                            formControlName="contactFormModalMessage">
                                   </textarea>
                          <mdb-error
                            *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                            {{ 'texto_61' | translate }}
                          </mdb-error>
                          <mdb-success
                            *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
                            {{ 'texto_62' | translate }} </mdb-success>
                        </div>

                        <!-- Botón guardar -->
                        <div class="text-center mt-3">
                          <button (click)="updateLayer(validatingForm.get('signupFormModalId').value)" mdbBtn
                            rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect>
                            {{ 'texto_59' | translate }}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>


              <app-add-abogado></app-add-abogado>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>